import main from './src/main.vue';

export default main;